<template>
  <div>
    <el-col :span="24">
      <el-form
        class="systemFont2 systemForm1"
        :model="formData"
        label-position="right"
        ref="formData"
        label-width="100px"
        hide-required-asterisk
      >
        <el-row>
          <!-- 新增个人用户 -->
          <p style="text-align: center; margin-right: 3%;">
            <span class="systemFont1">{{ $t("p0211.addIndividualUser") }}</span>
          </p>
          <!-- 模板导入 -->
          <el-form-item class="templateImportCss">
            <el-button type="submit" @click="formVisible = true">{{
              $t("p0211.templateImport")
            }}</el-button>
          </el-form-item>
          <!-- 头像 -->
          <el-col :span="8" style="margin-top:3%;">
            <el-form-item ref="imagePortrait">
              <el-row>
                <el-col :span="3" :offset="8">
                  <el-avatar :src="imageBase64"></el-avatar>
                </el-col>
                <el-col :span="3">
                  <el-upload
                    action="#"
                    ref="upload"
                    :limit="1"
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="handleChange"
                    class="hdPortraitCss"
                  >
                    <!--  -->
                    <el-button type="text" accept="image,jpeg">{{
                      $t("p0211.upload")
                    }}</el-button>
                  </el-upload>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="9" :offset="3">
            <el-form-item label-width="0px" style="margin-left:30px">
              <el-col :span="10">
                <!-- 姓 -->
                <el-form-item
                  :label="$t('p0211.lastName')"
                  prop="lastName"
                  :rules="rulesLastName"
                  label-width="70px"
                >
                  <el-input
                    v-model="formData.lastName"
                    size="reportContentInput"
                    class="inputWidth2"
                    :placeholder="$t('common.required')"
                    maxlength="125"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <!-- 名 -->
                <el-form-item
                  :label="$t('p0211.firstName')"
                  prop="firstName"
                  :rules="rulesFirstName"
                  label-width="70px"
                >
                  <el-input
                    v-model="formData.firstName"
                    size="reportContentInput"
                    class="inputWidth2"
                    :placeholder="$t('common.required')"
                    maxlength="125"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
            <!-- 昵称 -->
            <el-form-item :label="$t('p0211.nickName')" prop="nickName">
              <el-input
                v-model="formData.nickName"
                size="reportContentInput"
                class="inputWidth"
                maxlength="125"
              >
              </el-input>
            </el-form-item>
            <!-- 邮箱 -->
            <el-form-item :label="$t('p0211.email')">
              <div v-for="(item, index) in formData.emailList" :key="index">
                <el-col :span="18">
                  <el-form-item
                    :prop="index < 3 ? `emailList.${index}.email` : ''"
                    :rules="
                      index < 1
                        ? checkEmail0
                        : index < 2
                        ? checkEmail1
                        : checkEmail2
                    "
                  >
                    <el-input
                      ref="email"
                      size="reportContentInput"
                      v-model="item.email"
                      style="width: 100%; text-align: left"
                      @blur="emailInputBlur(index)"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-form-item class="plusAndMinus">
                    <img
                      v-if="index == 0"
                      class="add-icon"
                      src="@/assets/add.svg"
                      @click="addInput()"
                    />
                    <img
                      v-if="index != 0"
                      class="subtract-icon"
                      src="@/assets/subtract.svg"
                      @click="deleteInput(item)"
                    />
                    <!-- <el-button
                      @click="addInput()"
                      type="text"
                      icon="el-icon-plus"
                      v-if="index < 2 ? true : false"
                      
                    ></el-button> -->
                    <!-- <el-button
                      @click="deleteInput(item)"
                      type="text"
                      icon="el-icon-minus"
                      v-if="index > 0 ? true : false"
                    >
                    </el-button> -->
                  </el-form-item>
                </el-col>
              </div>
            </el-form-item>
            <!-- "再职公司/机构" -->
            <el-form-item :label="$t('p0211.inCompany')" prop="inCompany">
              <el-autocomplete
                class="inputWidth"
                size="systemSelect3"
                v-model="formData.inCompany"
                :fetch-suggestions="querySearch"
                placeholder=""
                :trigger-on-focus="false"
                @select="handleSelect"
                clearable
              ></el-autocomplete>
            </el-form-item>
            <!--  职位-->
            <el-form-item :label="$t('p0211.position')" prop="position">
              <el-input
                v-model="formData.position"
                size="reportContentInput"
                class="inputWidth"
                maxlength="64"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9" :offset="0">
            <!-- 英文姓 -->
            <el-form-item label-width="0px" style="margin-left:30px">
              <el-col :span="10">
                <el-form-item
                  :label="$t('p0211.englishLastName')"
                  prop="englishLastName"
                  :rules="checkEnglishLastName"
                  label-width="70px"
                >
                  <el-input
                    v-model="formData.englishLastName"
                    size="reportContentInput"
                    class="inputWidth2"
                    maxlength="125"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <!-- 英文名 -->
                <el-form-item
                  :label="$t('p0211.englishFirstName')"
                  prop="englishFirstName"
                  :rules="checkEnglishFirstName"
                  maxlength="125"
                  label-width="70px"
                >
                  <el-input
                    v-model="formData.englishFirstName"
                    size="reportContentInput"
                    class="inputWidth2"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
            <!-- 性别 -->
            <el-form-item :label="$t('p0211.sex')">
              <el-select
                class="inputWidth"
                v-model="formData.sex"
                size="systemSelect3"
                :placeholder="$t('p0211.sexSelection')"
              >
                <el-option
                  v-for="item in sexOpList"
                  :key="item.codeKey"
                  :label="item.codeValue"
                  :value="item.codeKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!--  手机-->
            <el-form-item :label="$t('p0211.telephone')">
              <div
                style="display: flex"
                v-for="(telephone, index) in formData.phoneList"
                :key="index"
              >
                <el-col :span="6">
                  <el-form-item>
                    <el-select
                      v-model="telephone.phoneArea"
                      size="systemSelect3"
                      :placeholder="$t('p0211.phoneArea')"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in phoneAreaOpList"
                        :key="item.codeValue"
                        :label="item.codeValue"
                        :value="item.codeValue"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11" :offset="1">
                  <el-form-item
                    :prop="index < 3 ? `phoneList.${index}.phone` : ''"
                    :rules="
                      index < 1
                        ? checkPhone0
                        : index < 2
                        ? checkPhone1
                        : checkPhone2
                    "
                  >
                    <el-input
                      ref="phone"
                      v-model="telephone.phone"
                      size="reportContentInput"
                      style=" text-align: left; "
                      @blur="phoneInputBlur(index)"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-form-item class="plusAndMinus">
                    <img
                      v-if="index == 0"
                      class="add-icon"
                      src="@/assets/add.svg"
                      @click="addInput2()"
                    />
                    <img
                      v-if="index != 0"
                      class="subtract-icon"
                      src="@/assets/subtract.svg"
                      @click="deleteInput2(telephone)"
                    />
                    <!-- <el-button
                      @click="addInput2()"
                      type="text"
                      icon="el-icon-plus"
                      v-if="index < 2 ? true : false"
                    >
                    </el-button>
                    <el-button
                      @click="deleteInput2(telephone)"
                      type="text"
                      icon="el-icon-minus"
                      v-if="index > 0 ? true : false"
                    >
                    </el-button> -->
                  </el-form-item>
                </el-col>
              </div>
            </el-form-item>
            <!-- 部门 -->
            <el-form-item :label="$t('p0211.department')" prop="department">
              <el-input
                v-model="formData.department"
                size="reportContentInput"
                class="inputWidth"
                maxlength="64"
              >
              </el-input>
            </el-form-item>
            <!-- 备注 -->
            <el-form-item :label="$t('p0211.remarks')" prop="remarks">
              <el-input
                class="inputWidth textAreaCss"
                v-model="formData.remarks"
                type="textarea"
                size="reportLongContentInput"
                :rows="3"
                maxlength="360"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="foot-container">
          <el-col :span="12">
            <!--提交  -->
            <el-button type="submit" @click.native.prevent="submit()">{{
              $t("p0211.submit")
            }}</el-button>
          </el-col>
          <el-col :span="12">
            <!-- 清空 -->
            <el-button type="return" @click.native.prevent="handlEmpty()">{{
              $t("p0211.handlEmpty")
            }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-col>
    <el-dialog
      :visible.sync="formVisible"
      :close-on-click-modal="false"
      @close="closeDialog()"
      class="templateDialogCss"
    >
      <!--  下载模板-->
      <div>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-button @click.native="download">{{
              $t("p0211.downloadTemplate")
            }}</el-button>
          </el-col>
          <el-col :span="8" :offset="2">
            <!-- 上传模板 -->
            <el-upload
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="templateChange"
              ref="xlsxTamplate"
            >
              <el-button>{{ $t("p0211.uploadTemplate") }}</el-button>
            </el-upload>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <!-- 错误信息 -->
    <el-dialog
      :visible.sync="listVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      class="dialog"
    >
      <el-table :data="errMsgList" style="margin-bottom: 75px">
        <el-table-column label="错误信息" align="center" class="errdialog">
          <template slot-scope="scope">
            <span class="errdialog">{{ scope.row }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import * as imageConversion from "image-conversion";
export default {
  data() {
    var validateEmailList0 = (rule, value, callback) => {
      // if (!value) {
      //   return callback(new Error(this.$t("p0211.checkEmail")));
      // } else {
      if (value) {
        let rules1 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!rules1.test(value)) {
          return callback(new Error(this.$t("p0211.correctEmail")));
        } else {
          for (let i = 0; i < this.formData.emailList.length; i++) {
            if (i != 0 && this.formData.emailList[i].email != "") {
              if (
                this.formData.emailList[i].email.toLowerCase() ==
                value.toLowerCase()
              ) {
                return callback(new Error(this.$t("p0211.replaceEmail")));
              }
            }
          }
        }
      }
      callback();
    };
    var validateEmailList1 = (rule, value, callback) => {
      if (value) {
        let rules1 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!rules1.test(value)) {
          return callback(new Error(this.$t("p0211.correctEmail")));
        } else {
          for (let i = 0; i < this.formData.emailList.length; i++) {
            if (i != 1 && this.formData.emailList[i].email != "") {
              if (
                this.formData.emailList[i].email.toLowerCase() ==
                value.toLowerCase()
              ) {
                return callback(new Error(this.$t("p0211.replaceEmail")));
              }
            }
          }
        }
      }
      callback();
    };
    var validateEmailList2 = (rule, value, callback) => {
      if (value) {
        let rules1 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!rules1.test(value)) {
          return callback(new Error(this.$t("p0211.correctEmail")));
        } else {
          for (let i = 0; i < this.formData.emailList.length; i++) {
            if (i != 2 && this.formData.emailList[i].email != "") {
              if (
                this.formData.emailList[i].email.toLowerCase() ==
                value.toLowerCase()
              ) {
                return callback(new Error(this.$t("p0211.replaceEmail")));
              }
            }
          }
        }
      }
      callback();
    };
    var validatePhoneList0 = (rule, value, callback) => {
      // if (!value) {
      //   return callback(new Error(this.$t("p0211.checkPhone")));
      // } else {
      if (value) {
        let rules2 = /^[0-9]+$/;
        if (!rules2.test(value)) {
          return callback(new Error(this.$t("p0211.telephoneFormat")));
        } else {
          for (let i = 0; i < this.formData.phoneList.length; i++) {
            if (i != 0 && this.formData.phoneList[i].phone != "") {
              if (
                this.formData.phoneList[i].phoneArea ==
                this.formData.phoneList[0].phoneArea
              ) {
                if (this.formData.phoneList[i].phone == value) {
                  return callback(new Error(this.$t("p0211.replacePhone")));
                }
              }
            }
          }
        }
      }
      callback();
    };
    var validatePhoneList1 = (rule, value, callback) => {
      if (value) {
        let rules2 = /^[0-9]+$/;
        if (!rules2.test(value)) {
          return callback(new Error(this.$t("p0211.telephoneFormat")));
        } else {
          for (let i = 0; i < this.formData.phoneList.length; i++) {
            if (i != 1 && this.formData.phoneList[i].phone != "") {
              if (
                this.formData.phoneList[i].phoneArea ==
                this.formData.phoneList[1].phoneArea
              ) {
                if (this.formData.phoneList[i].phone == value) {
                  return callback(new Error(this.$t("p0211.replacePhone")));
                }
              }
            }
          }
        }
      }
      callback();
    };
    var validatePhoneList2 = (rule, value, callback) => {
      if (value) {
        let rules2 = /^[0-9]+$/;
        if (!rules2.test(value)) {
          return callback(new Error(this.$t("p0211.telephoneFormat")));
        } else {
          for (let i = 0; i < this.formData.phoneList.length; i++) {
            if (i != 2 && this.formData.phoneList[i].phone != "") {
              if (
                this.formData.phoneList[i].phoneArea ==
                this.formData.phoneList[2].phoneArea
              ) {
                if (this.formData.phoneList[i].phone == value) {
                  return callback(new Error(this.$t("p0211.replacePhone")));
                }
              }
            }
          }
        }
      }
      callback();
    };
    // 验证规则 - 姓
    const checkLastName = (rule, value, callback) => {
      const checkNotNull = this.checkNotNull(this.formData.firstName);
      const isChinese = /^[\u4e00-\u9fa5]+$/.test(value); // 判断是否为中文
      const isEnglish = /^[a-zA-Z]+$/.test(value); // 判断是否为英文
      if ((isChinese && !isEnglish) || (isEnglish && !isChinese)) {
        const isChineseFirstName = /^[\u4e00-\u9fa5]+$/.test(
          this.formData.firstName
        ); // 获取姓是否为中文
        const isEnglishFirstName = /^[a-zA-Z]+$/.test(this.formData.firstName); // 获取姓是否为英文
        if (checkNotNull && isChineseFirstName) {
          // 姓是中文
          if (value && !/^[\u4e00-\u9fa5]+$/.test(value)) {
            // 名不是中文
            callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
          } else {
            this.$refs.formData.clearValidate("firstName");
            callback(); // 校验通过
          }
        } else if (checkNotNull && isEnglishFirstName) {
          // 姓是英文
          if (value && !/^[a-zA-Z]+$/.test(value)) {
            // 名不是英文
            callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
          } else {
            this.$refs.formData.clearValidate("firstName");
            callback(); // 校验通过
          }
        } else if (checkNotNull) {
          // 姓不是中文也不是英文
          callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
        }
      } else {
        callback(new Error(this.$t("p0211.msg3"))); // 校验不通过，抛出错误信息
      }
    };

    // 验证规则 - 名
    const checkFirstName = (rule, value, callback) => {
      const checkNotNull = this.checkNotNull(this.formData.lastName);
      const isChineseLastName = /^[\u4e00-\u9fa5]+$/.test(
        this.formData.lastName
      ); // 获取姓是否为中文
      const isEnglishLastName = /^[a-zA-Z]+$/.test(this.formData.lastName); // 获取姓是否为英文
      const isChinese = /^[\u4e00-\u9fa5]+$/.test(value); // 判断是否为中文
      const isEnglish = /^[a-zA-Z]+$/.test(value); // 判断是否为英文
      if ((isChinese && !isEnglish) || (isEnglish && !isChinese)) {
        // 判断语言是否一致
        if (checkNotNull && isChineseLastName) {
          // 姓是中文
          if (value && !/^[\u4e00-\u9fa5]+$/.test(value)) {
            // 名不是中文
            callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
          } else {
            this.$refs.formData.clearValidate("lastName");
            callback(); // 校验通过
          }
        } else if (checkNotNull && isEnglishLastName) {
          // 姓是英文
          if (value && !/^[a-zA-Z]+$/.test(value)) {
            // 名不是英文
            callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
          } else {
            this.$refs.formData.clearValidate("lastName");
            callback(); // 校验通过
          }
        } else if (checkNotNull) {
          // 姓不是中文也不是英文
          callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
        }
      } else {
        callback(new Error(this.$t("p0211.msg3"))); // 校验不通过，抛出错误信息
      }
    };
    return {
      formData: {
        headPortrait: "",
        lastName: "",
        firstName: "",
        nickName: "",
        inCompany: "",
        position: "",
        englishLastName: "",
        englishFirstName: "",
        sex: "",
        department: "",
        remarks: "",
        createUser: localStorage.getItem("userId"),
        emailList: [
          {
            email: ""
          }
        ],
        phoneList: [
          {
            phone: "",
            // 区号，默认+86
            phoneArea: ""
          }
        ]
      },
      getlistLoading: false,
      // 验证邮箱判定
      validateEmailFlag: true,
      // 验证手机号判定
      validatePhoneFlag: true,
      // 对话框是否显示
      formVisible: false,
      // 错误信息
      errMsgList: [],
      // 错误信息对话框是否显示
      listVisible: false,
      isdisabled: false,
      loading: false,
      // 头像
      imageBase64: "",
      avatarDialog: false,
      uploadFile: "",
      // 提交上传文件时的数据
      reportFileData: "",
      // 性别
      sexOpList: [],
      // 区号
      phoneAreaOpList: [],
      emailFLg: false,
      phoneFLg: false,
      // 校验
      rulesLastName: [
        {
          required: true,
          message: this.$t("p0211.checkLastName"),
          trigger: "blur"
        },
        { required: false, validator: checkLastName, trigger: "blur" }
      ],
      rulesFirstName: [
        {
          required: true,
          message: this.$t("p0211.checkFirstName"),
          trigger: "blur"
        },
        { required: false, validator: checkFirstName, trigger: "blur" }
      ],
      checkEnglishLastName: [
        {
          required: false,
          message: this.$t("p0211.checkEnglishLastName"),
          trigger: "blur"
        },
        {
          pattern: /^[a-zA-Z]+$/,
          message: this.$t("p0211.checkEnglishOnly"),
          trigger: "blur"
        }
      ],
      checkEnglishFirstName: [
        {
          required: false,
          message: this.$t("p0211.checkEnglishFirstName"),
          trigger: "blur"
        },
        {
          pattern: /^[a-zA-Z]+$/,
          message: this.$t("p0211.checkEnglishOnly"),
          trigger: "blur"
        }
      ],
      checkEmail0: [
        { required: false, validator: validateEmailList0, trigger: "blur" }
      ],
      checkEmail1: [
        { required: false, validator: validateEmailList1, trigger: "blur" }
      ],
      checkEmail2: [
        { required: false, validator: validateEmailList2, trigger: "blur" }
      ],
      checkPhone0: [
        { required: false, validator: validatePhoneList0, trigger: "blur" }
      ],
      checkPhone1: [
        { required: false, validator: validatePhoneList1, trigger: "blur" }
      ],
      checkPhone2: [
        { required: false, validator: validatePhoneList2, trigger: "blur" }
      ]
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    checkNotNull(str) {
      if (str === null || str === "" || typeof str === "undefined") {
        return false;
      } else {
        return true;
      }
    },
    // 初始化数据
    initData() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/individualUser/initData";
      this.$http
        .post(
          url,
          qs.stringify({
            createUser: localStorage.getItem("userId"), // 登录后台管理系统的用户ID
            sysLanguage: "zh" // 当前选择的语言，当前只设定中文
          })
        )
        .then(response => {
          // console.log("response:" + JSON.stringify(response.data.data));
          // 性别下拉框数据
          this.sexOpList = response.data.data.sexOpList;
          this.formData.sex = response.data.data.sexOpList[0].codeKey;
          // 区号下拉框数据
          this.phoneAreaOpList = response.data.data.phoneAreaOpList;
          this.formData.phoneList[0].phoneArea =
            response.data.data.phoneAreaOpList[0].codeValue;
          // 头像图片初始化
          if (response.data.data.imageBase64 == null) {
            this.imageBase64 = require("../../assets/headPortrait.png");
            // "../../assets/headPortrait.png";
          }
          loading.close();
        })
        .catch(err => {
          loading.close();
          console.log(err);
          this.$message.error(this.$t("p0211.errorOccurred"));
        });
    },
    // 公司机构的建议数据取得
    querySearch(queryString, cb) {
      let url = "/api/individualUser/getCompanyNames";
      this.$http
        .post(
          url,
          qs.stringify({
            inCompany: queryString
          })
        )
        .then(response => {
          if (response.data.code === 200) {
            // 调用 callback 返回建议列表的数据
            console.log("公司", JSON.stringify(response.data.data));
            cb(response.data.data.companyOptionList);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("p0211.errorOccurred"));
        });
    },
    handleSelect(item) {
      console.log(item);
    },
    // 头像
    handleChange(file, fileList) {
      this.$refs.upload.clearFiles();
      if (this.beforeAvatarUpload(file.raw)) {
        // this.formData.headPortrait = file.raw;
        this.imageBase64 = URL.createObjectURL(file.raw);
      }
    },
    // beforeAvatarUpload方法里：
    beforeAvatarUpload(file) {
      console.log(file);
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      console.log(isJPG);
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error(this.$t("p0211.imageFormat"));
      }
      if (!isLt2M) {
        this.$message.error(this.$t("p0211.imageSize"));
      }
      // 压缩
      if (isJPG && isLt2M) {
        imageConversion.compressAccurately(file, 1).then(res => {
          // console.log(res)
          this.formData.headPortrait = new window.File([res], file.name, {
            type: file.type
          }); // 将blob类型转为file
          // console.log("文件",this.formData.headPortrait)
        });
      }
      return isJPG && isLt2M;
    },
    // 添加邮箱
    addInput() {
      if (this.formData.emailList.length < 3) {
        this.formData.emailList.push({
          email: ""
        });
        console.log(this.$t("p0211.length") + this.formData.emailList.length);
      } else {
        this.$message({
          message: this.$t("p0211.maxEmail"),
          type: "warning"
        });
      }
    },
    // 删除邮箱
    deleteInput(inputIndex) {
      if (this.formData.emailList.length === 1) {
        this.formData.emailList = [
          {
            email: ""
          }
        ];
        return this.formData.emailList;
      }
      let index = this.formData.emailList.indexOf(inputIndex);

      if (index != -1) {
        this.formData.emailList.splice(index, 1);
      }
    },
    // 邮箱光标移出
    emailInputBlur(index) {
      if (this.validateEmailFlag) {
        for (let i = 0; i < this.$refs["email"].length; i++) {
          if (index != i) {
            this.validateEmailFlag = false;
            this.$refs["email"][i].focus();
            this.$refs["email"][i].blur();
          }
          if (i == this.$refs["email"].length - 1) {
            this.validateEmailFlag = true;
          }
        }
      }
    },
    // 添加手机号
    addInput2() {
      if (this.formData.phoneList.length < 3) {
        this.formData.phoneList.push({
          phoneArea: this.phoneAreaOpList[0].codeValue,
          phone: ""
        });
        console.log(this.$t("p0211.length") + this.formData.phoneList.length);
      } else {
        this.$message({
          message: this.$t("p0211.maxPhone"),
          type: "warning"
        });
      }
    },
    // 删除手机号
    deleteInput2(inputIndex) {
      if (this.formData.phoneList.length === 1) {
        this.formData.phoneList = [
          {
            phoneArea: this.phoneAreaOpList[0].codeValue,
            phone: ""
          }
        ];
        return this.formData.phoneList;
      }
      let index = this.formData.phoneList.indexOf(inputIndex);

      if (index != -1) {
        this.formData.phoneList.splice(index, 1);
      }
    },
    // 手机号光标移出
    phoneInputBlur(index) {
      if (this.validatePhoneFlag) {
        for (let i = 0; i < this.$refs["phone"].length; i++) {
          if (index != i) {
            this.validatePhoneFlag = false;
            this.$refs["phone"][i].focus();
            this.$refs["phone"][i].blur();
          }
          if (i == this.$refs["phone"].length - 1) {
            this.validatePhoneFlag = true;
          }
        }
      }
    },
    // 提交
    submit() {
      // 检查邮箱和手机号，必须有一个输入
      for (let i = 0; i < this.formData.emailList.length; i++) {
        if (
          this.formData.emailList[i].email != null &&
          this.formData.emailList[i].email != ""
        ) {
          this.emailFLg = true;
          continue;
        }
      }
      for (let i = 0; i < this.formData.phoneList.length; i++) {
        if (
          this.formData.phoneList[i].phone != "" &&
          this.formData.phoneList[i].phone != null
        ) {
          this.phoneFLg = true;
          continue;
        }
      }
      if (this.emailFLg || this.phoneFLg) {
        this.$refs["formData"].validate(valid => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: this.$t("common.loading"),
              background: "rgba(255,255,255,0.8)",
              target: document.querySelector("#main-container")
            });
            let imgfile = new FormData();
            imgfile.append("multipartFiles", this.formData.headPortrait);
            imgfile.append("material", JSON.stringify(this.formData));
            let url = "/api/individualUser/submit";
            // let formData = new FormData()
            // let file = item.raw
            // formData.append('file', file)
            this.$http
              .post(url, imgfile)
              .then(response => {
                if (response.data.code === 200) {
                  loading.close();
                  this.$message.success(this.$t("p0211.individualuser"));
                  this.phoneFLg = false;
                  this.emailFLg = false;
                  this.handlEmpty();
                } else {
                  loading.close();
                  this.$message.error(response.data.message);
                }
                loading.close();
              })
              .catch(err => {
                loading.close();
                console.log(err);
                this.$message.error(this.$t("p0211.errorOccurred"));
              });
          }
        });
      } else {
        this.$message({
          message: this.$t("p0211.mustInput"),
          type: "warning"
        });
      }
    },
    // 清空
    handlEmpty() {
      // 入力项目清空
      this.$refs["formData"].resetFields();
      // 邮箱和电话初期化
      this.formData.emailList = [{ email: "" }];
      this.formData.phoneList = [{ phone: "", phoneArea: "" }];
      // 下拉框默认选项初期化
      this.formData.sex = this.sexOpList[0].codeKey;
      this.formData.phoneList[0].phoneArea = this.phoneAreaOpList[0].codeValue;
      // 头像清空
      this.$refs.upload.clearFiles();
      this.formData.headPortrait = null;
      this.imageBase64 = require("../../assets/headPortrait.png");
    },
    // 对话框关闭
    closeDialog() {
      // 移除表单校验
      // this.$refs.form.clearValidate();
    },
    // 下载模板
    download() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/individualUser/downloadTemplate";
      this.$http
        .get(url, { responseType: "blob" })
        .then(response => {
          // console.log("文件下载成功", response.data);
          const blob = new Blob([response.data]);
          console.log("blob", blob);
          this.formVisible = false;
          if (blob.size == 0) {
            this.$message.error(this.$t("p0211.existTemplate"));
            loading.close();
          } else {
            const fileName = this.$t("p0211.fileName");
            //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
            //IE10以上支持blob，但是依然不支持download
            if ("download" in document.createElement("a")) {
              console.log("download1");
              //支持a标签download的浏览器
              const link = document.createElement("a"); //创建a标签
              link.download = fileName; //a标签添加属性
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              document.body.appendChild(link);
              link.click(); //执行下载
              URL.revokeObjectURL(link.href); //释放url
              document.body.removeChild(link); //释放标签
            } else {
              console.log("download2");
              navigator.msSaveBlob(blob, fileName);
            }
            loading.close();
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("p0211.errorTemplate"));
          loading.close();
        });
    },
    // 上传模板
    templateChange(file, fileList) {
      console.log("test:", file);
      this.$refs.xlsxTamplate.clearFiles();
      if (this.beforeAvatarUploadTemplate(file.raw)) {
        this.uploadFile = file.raw;

        const loading = this.$loading({
          lock: true,
          text: this.$t("common.loading"),
          background: "rgba(255,255,255,0.8)",
          target: document.querySelector("#main-container")
        });
        let templatefiles = new FormData();
        templatefiles.append("file", this.uploadFile);
        templatefiles.append(
          "material",
          JSON.stringify(this.formData.createUser)
        );
        let url = "/api/individualUser/uploadTemplate";
        // let formData = new FormData()
        // let file = item.raw
        // formData.append('file', file)
        this.$http
          .post(url, templatefiles)
          .then(response => {
            this.formVisible = false;
            if (response.data.code === 200) {
              if (response.data.data.length == 0) {
                (this.listVisible = false),
                  this.$message.success(this.$t("p0211.importSuccess"));
              } else {
                (this.listVisible = true),
                  (this.errMsgList = response.data.data);
                // console.log("错误信息：" + response.data.data);
              }
              // console.log(response.data.data);
              loading.close();
            } else {
              loading.close();
              this.$message.error(response.data.message);
            }
            loading.close();
          })
          .catch(err => {
            loading.close();
            console.log(err);
            this.$message.error(this.$t("p0211.importFailure"));
          });
      }
    },
    beforeAvatarUploadTemplate(file) {
      console.log(file);
      // 设置文件类型
      var i = file.name.substring(file.name.lastIndexOf(".") + 1);
      console.log(i);
      const isXLS = i === "xlsx" || i === "xls";
      console.log(isXLS);
      if (!isXLS) {
        this.$message.error(this.$t("p0211.templateTypeErr"));
      }
      return isXLS;
    }
  }
};
</script>

<style lang="scss" scoped>
// 上传头像的按钮样式
// .uploaderHeadPortraitClass{
// }
.plusAndMinus {
  text-align: left;
}
// 入力框
.inputWidth {
  display: block;
  width: 75%;
}
// 姓名入力框
.inputWidth2 {
  display: block;
  width: 82%;
}
// 头像
.hdPortraitCss {
  display: block;
  padding-left: 10px;
}
// 模板导入按钮
.templateImportCss {
  text-align: right;
  width: 82%;
}
// 模板dialog
.templateDialogCss {
  text-align: center;
  margin-top: 3%;
  margin-left: 10%;
}
.textAreaCss {
  margin-top: 9px;
}
.foot-container {
  margin-top: 5%;
  margin-left: 38%;
  width: 20%;
  text-align: center;
}
>>> .el-dialog__body {
  height: auto;
  text-align: center;
}
// .dialog {
//   width: 1200px;
//   text-align: center;
//   margin: auto;
//   display: flex;
//   justify-content: center;
//   align-items: Center;
//   overflow: hidden;
//   >>> .el-dialog {
//     margin: 0 auto !important;
//     height: 74%;
//     overflow: hidden;
//   }
// }
.dialog {
  width: 1280px;
  text-align: center;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
  >>> .el-dialog {
    margin: 0 auto !important;
    max-height: 80%;
    height: 80%;
    overflow: hidden;
    .el-dialog__body {
      position: absolute;
      left: 15px;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
    }
    >>> .el-table .el-table__cell {
      padding: 7px 0;
    }
  }
}
.errdialog {
  height: 15px;
  border-color: rgb(204, 204, 204);
  font-size: 16px;
  font-family: Microsoft YaHei;
  padding: 7px 0;
}
.el-table {
  font-size: 16px;
}
// 加号图标的样式
.add-icon {
  float: left;
  position: relative;
  top: 13px;
  left: 10px;
  cursor: pointer;
}

// 减号图标的样式
.subtract-icon {
  float: left;
  position: relative;
  top: 18px;
  left: 9px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/CustomerInfoBase/P0211.vue